export const PAGE_TITLE = {
    '/distributor/support/companymove': 'Company Move',
};
